numeral.language('nl-nl');

$(function() {

  // $(document).on('click', '.user-hour-input__input input[type=time]', function(e){
    // if($(this).val() === '') {
      // $(this).val('00:00');
    // }
  // });

  // $(document).on('focus', '.user-hour-input__cell:not(.user-hour-input__cell--active) .user-hour-input__input input', function(e){
    // updateActiveCell();
    // $(this).closest('.user-hour-input__cell').addClass('user-hour-input__cell--active');
  // });

  // $(document).mouseup(function(e) {
    // var container = $('.user-hour-input__cell--active');
    // if (!container.is(e.target) && container.has(e.target).length === 0) {
      // updateActiveCell();
    // }
  // });

  // function updateActiveCell() {
    // if ($('.user-hour-input__cell--active .user-hour-input__item--comment textarea').val() === ''){
      // $('.user-hour-input__cell--active').removeClass('user-hour-input__cell--comment');
    // }
    // $('.user-hour-input__cell--active').removeClass('user-hour-input__cell--active');
    // //$('.user-hour-input__item--comment').hide();
  // }

  // $(document).on('click', '.ttbtn.clear-cell', function(e){
  //   $(this).closest('.user-hour-input__cell').find('input').val('');
  //   e.preventDefault();
  // });

  // $(document).on('click', '.ttbtn.add-comment', function(e){
  //   $(this)
  //     .closest('.user-hour-input__cell')
  //     .find('.user-hour-input__item--comment')
  //     .eq(0).toggle();
  //   e.preventDefault();
  // });

  // $('.user-hour-input__cell--error').tipso({
  //   content: 'Dit blok kan niet worden opgeslagen.',
  //   tooltipHover: true,
  //   background: '#DF091E',
  //   color: '#FFFFFF',
  // }).tipso('show');

  $('.toggle-menu').on('click', function(e) {
    if(!$('.left').hasClass('animated')) {
      $('.left').addClass('animated');
    }
    $('body').toggleClass('show-menu');
    e.preventDefault();
  });

  $('.main-menu__item.has-submenu > .main-menu__link').on('click', function(e) {
    $(this).closest('.main-menu__item.has-submenu').toggleClass('visible');
    if(!$('body').hasClass('show-menu')){
      $('body').addClass('show-menu');
    }
    e.preventDefault();
  });

  if($('.popupbanner').length > 0) {
    // $(".popupbanner__close, .popupbanner--bg").click(function(e) {
    //   var expiryDate = new Date();
    //   expiryDate.setTime(expiryDate.getTime() + ((60 * 60 * 1000) * 24));
    //   $.cookie('showbanner', 'true', {
    //     expires: expiryDate,
    //     path: '/'
    //   });
    //   //e.preventDefault();
    // });
      $("body").addClass("showbanner");
  }

  // var showHeigth = ($('.site .right .dashboard').height() + $('.site .right .columns').height());
  // console.log(showHeigth);
  // console.log($('.site .right .dashboard').height() + $('.site .right .columns').height());
  // console.log($('.site .right .dashboard').height());
  // console.log($('.site .right .columns').height());
  // if (showHeigth != null) {
  //   $('.site, .site .right, .site .left').css("height", showHeigth + 20 + 'px');
  // } else {
  //   $('.site, .site .right, .site .left').css("min-height", '100vh');
  // }


});

$('.question__answer').on('click', function(e) {
  $(this).closest('.question').find('.question__answer').removeClass('question__answer--selected');
  $(this).addClass('question__answer--selected');
  e.preventDefault();
});

// Custom form effects
$(function() {
  $(".custom-form .input__field").on("change", function() {
    if ($(this).val() === "") {
      $(this).closest(".input").removeClass("input--filled");
    } else {
      $(this).closest(".input").addClass("input--filled");
    }
  });
});

// SVG buttons
// $(function() {
//   initSVGButtons();
// });

// $(document).ajaxComplete(function() {
//   initSVGButtons();
// });

function initSVGButtons() {
  var $button = $(".btnsvg:not(.svg-loaded)");
  $button.each(function() {
    $(this).wrapInner("<span class='btnsvg-txt' />");
    if (Modernizr.svg) {
      $(this)
        .addClass('svg-loaded')
        .append(
          '<span class="btnsvg-bg btnsvg-bg--left">' +
            '<svg viewBox="-2 0 302 32" x="0" y="0" preserveAspectRatio="xMinYMin slice" class="hex-svg">' +
              '<use xlink:href="#hex" class="hex-svg--left"></use>' +
            '</svg>' +
          '</span>' +
          '<span class="btnsvg-bg btnsvg-bg--right">' +
            '<svg viewBox="0 0 302 32" x="0" y="0" preserveAspectRatio="xMaxYMax slice" class="hex-svg">' +
              '<use xlink:href="#hex" class="hex-svg--right"></use>' +
            '</svg>' +
          '</span>');
    }
  });
}

// Submit current form
$(function() {
  $(document).on('click', '.btn-submit-current-form', function(e) {
    $(this).closest('form').submit();
    e.preventDefault();
  });

  $('.faq-item').on('click', '.title', function(e){
    $(this).closest('.faq-item').toggleClass('faq-item--open');
    e.preventDefault();
  });

  $('.profile-block__item__btn').on('click', function(e){
    $(this).closest('.profile-block__item').toggleClass('profile-block__item--editable');
    e.preventDefault();
  });

  $(document).on('click', '.band--menu .band__content > .btnsvg', function(e){
    window.location = $('.job-apply-btn__text').closest('a').attr('href');
    e.preventDefault();
  });

  $(document).on('blur focus focusin focusout', '.signup-form input[type=text], .signup-form input[type=number], .signup-form input[type=email], .job-search input[type=text], .job-search input[type=number], .job-search input[type=email]', function (e) {

    if ($(this).attr('data-toggle')) {
      $(this).addClass('focus');
      return;
    }

    if (e.type === "focus" || e.type === "focusin") {
      $(this).addClass('focus');
    } else {
      $(this).removeClass('focus');
    }

    if (e.type === "blur") {
      if ($(this).hasClass('required') && $(this).val() === "") {
        $(this).closest('.item__input, .form__input').removeClass('valid'); //.addClass('invalid');
      } else {
        $(this).closest('.item__input, .form__input').removeClass('invalid');
        if ($(this).val() !== "") {
          $(this).closest('.item__input, .form__input').addClass('valid');
        }
      }
    }

    if ($(this).val() !== "") {
      $(this).addClass('valid');
    } else {
      $(this).removeClass('valid');
    }

    e.preventDefault();
  });

  initCustomDropdown();

  $('[data-tipso]').tipso();
});

function initCustomDropdown() {

  setTimeout(function () {
    $('.signup-form select').each(function (index) {

      if ($(this).hasClass('select2-hidden-accessible') && $(this).find('option').length > 0) {
        $(this).select2('destroy');
      }

      $(this).select2({
        minimumResultsForSearch: -1,
        placeholder: $(this).find('option:eq(0)').text(),
        width: '100%'
      });

    });
  }, 100);

}
